globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.PrivateSpace = (function() {
  function PrivateSpace() {}

  PrivateSpace.activity = function() {
    var timer;

    document.onmousemove = resetTimer;
    document.onkeypress = resetTimer;
    document.onscroll = resetTimer;

    function logActivity() {
      $.post('/api-website-feature/private-spaces/activity', function(data) {

      }).fail(function() {});
    }

    function resetTimer() {
      clearTimeout(timer);

      timer = setTimeout(logActivity, 1500);
    }
  }

  return PrivateSpace;
})();
